module.exports = __webpack_public_path__ + "/img/03f4d8a65d76a40fb2e973c122ce8ab7.png";